import React, { Component } from 'react'

export default class Image extends Component {
    render() {
        return (
            <a href={this.props.info.remote_url} target="_blank">
                <div className="card randal shadow" >
                    <img src={this.props.info.remote_url} className="card-img-top" alt="..." />
                </div>
            </a>

        )
    }
}
